module.exports = __webpack_public_path__ + "static/img/zhutuSCW.eb95010.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type1-3/zhutuSCW.png
// module id = lFfu
// module chunks = 0